import styled from "@emotion/styled";
import { theme } from "@product/scmp-sdk";

export const TopLeftStarsContainer = styled.div`
  position: absolute;
  inset-block-start: -100px;
  inset-inline-start: 0;
`;

export const TopRightStarsContainer = styled.div`
  position: absolute;
  inset-block-start: -70px;
  inset-inline-end: 6.5vw;
`;

export const BottomLeftStarsContainer = styled.div`
  position: absolute;
  inset-block-start: 394px;
  inset-inline-start: 70px;
`;

export const BottomRightStarsContainer = styled.div`
  position: absolute;
  inset-block-start: 244px;
  inset-inline-end: 0;
`;

export const Container = styled.div`
  display: none;

  ${theme.breakpoints.up("largeDesktop")} {
    position: absolute;
    inset-block-start: 0;

    display: flex;

    inline-size: 100vw;
  }
`;
